import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

import type { Model } from "core/modules/state/model/Model"

export const useAppDispatch = useDispatch

export const useAppSelector: TypedUseSelectorHook<Model> = useSelector
